<select class="simple-select w-100" (change)="handlerChangeLanguage($event)">
  @for (item of languages; track $index) {
    <option value="{{ item.value }}" [selected]="this.currentLanguage === item.value">{{ item.label }}</option>
  }
</select>

<div class="d-flex justify-content-end m-t-20">
  <button type="button" class="btn btn-primary btn-sm" (click)="close()">
    {{ 'generic.close' | translate }}
  </button>
</div>
